export function usd (value: number | string): string {
  return `$${(+value).toFixed(2)}`
}
